import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import Draggable from "react-draggable";
import {
  Button,
  ConfigProvider,
  Descriptions,
  InputNumber,
  message,
} from "antd";
import Url from "../../../apiCall/UrlConfig";
import "../LaterallCephalo/cephalo.css";

const ImagePreAddress = Url.baseURL[0] + Url.downloadImage;

const CbctRuler = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [_Photo, setPhoto] = useState(null);
  const [realSizeMm, setRealSizeMm] = useState(10);
  const [pointPositions, setPointPositions] = useState({
    Ruller1: { x: 10, y: 10 },
    Ruller2: { x: 10, y: 100 },
  });

  useEffect(() => {
    GetRuler();
  }, []);

  const GetRuler = async () => {
    let url = Url.GetCbctRuler;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {
      id: parseInt(id),
    });

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }

    setPhoto(res?.data?.image);

    let ruler = res?.data?.ruler;
    if (ruler) {
      setPointPositions({
        Ruller1: { x: ruler.x1, y: ruler.y1 },
        Ruller2: { x: ruler.x2, y: ruler.y2 },
      });
      setRealSizeMm(ruler.realSizeMm);
    }
  };

  const _onstop = (event, data, label) => {
    let x = parseInt(data.x.toFixed());
    let y = parseInt(data.y.toFixed());

    setPointPositions((prevPositions) => ({
      ...prevPositions,
      [label]: { x: x, y: y },
    }));
  };

  const calculateDistance = (point1, point2) => {
    const dx = point2.x - point1.x;
    const dy = point2.y - point1.y;
    return Math.sqrt(dx * dx + dy * dy);
  };

  const distanceInPixel = calculateDistance(
    pointPositions.Ruller1,
    pointPositions.Ruller2
  );

  const pixelPerMm = realSizeMm > 0 ? distanceInPixel / realSizeMm : 0;

  const _returnDraggbleView = () => {
    let _output = [];
    for (let key in pointPositions) {
      _output.push(
        <Draggable
          key={key}
          onStop={(event, data) => _onstop(event, data, key)}
          defaultPosition={pointPositions[key]}
          position={pointPositions[key]}
        >
          <div className="DragableContainer">
            <div className="circlePoint" />
            <div className="labelPoint">{key}</div>
          </div>
        </Draggable>
      );
    }
    return _output;
  };

  const _SaveRuler = async () => {
    if (!realSizeMm || realSizeMm <= 0) {
      message.warning("اندازه واقعی باید بزرگتر از صفر باشد");
      return;
    }

    if (distanceInPixel === 0) {
      message.warning("دو نقطه نباید روی هم باشند");
      return;
    }

    let url = Url.SaveCbctRuler;

    let data = {
      ImageId: parseInt(id),
      X1: pointPositions.Ruller1.x,
      Y1: pointPositions.Ruller1.y,
      X2: pointPositions.Ruller2.x,
      Y2: pointPositions.Ruller2.y,
      RealSizeMm: realSizeMm,
    };

    let res = await props.actions.CallCoreServicesActionWithToken(url, data);

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }

    message.success(res.message);
    navigate("/cbctai/mainpage");
  };

  return (
    <div dir="ltr">
      {_Photo != null && (
        <>
          <div
            style={{
              position: "relative",
              width: _Photo.imageWidth,
              height: _Photo.imageHeight,
            }}
          >
            <img
              src={ImagePreAddress + _Photo.imageUrl}
              className="imageCephalo"
              draggable={false}
              alt="cbct"
            />
            <svg
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                pointerEvents: "none",
              }}
              width={_Photo.imageWidth}
              height={_Photo.imageHeight}
            >
              <line
                x1={pointPositions.Ruller1.x}
                y1={pointPositions.Ruller1.y}
                x2={pointPositions.Ruller2.x}
                y2={pointPositions.Ruller2.y}
                stroke="red"
                strokeWidth={1}
              />
            </svg>
            {_returnDraggbleView()}
          </div>

          <div style={{ marginTop: 10 }}>
            <span style={{ marginRight: 8 }}>اندازه واقعی (میلی متر) :</span>
            <InputNumber
              min={0.1}
              step={0.1}
              value={realSizeMm}
              onChange={(value) => setRealSizeMm(value)}
            />
          </div>

          <ConfigProvider direction="ltr">
            <Descriptions bordered title="Cbct Ruler" style={{ marginTop: 10 }}>
              <Descriptions.Item label="Distance (pixel)">
                {distanceInPixel.toFixed(2)}
              </Descriptions.Item>
              <Descriptions.Item label="Real Size (mm)">
                {realSizeMm}
              </Descriptions.Item>
              <Descriptions.Item label="Pixel per mm">
                {pixelPerMm.toFixed(3)}
              </Descriptions.Item>
            </Descriptions>
          </ConfigProvider>

          <Button
            style={{ marginTop: 10 }}
            type="primary"
            loading={props.coreData[Url.SaveCbctRuler]?.[Url.action]?.isFetching}
            onClick={_SaveRuler}
          >
            Save Ruler
          </Button>
        </>
      )}
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(mapStateToProps, mapDispatchToProps)(CbctRuler);
